<template>

  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <a-form layout="vertical">
          <a-form-item
            label="项目删除"
          >
            <a-button type="danger" @click="handleDelete">删除</a-button>
          </a-form-item>

          <a-form-item
            label="项目转让"
          >
            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <select-project-user ref="user"/>
              </a-col>
              <a-col :md="8" :sm="12">
                <a-button type="primary" @click="handleSave">转让</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

  </div>
</template>

<script>
import SelectProjectUser from '@/components/selector/SelectProjectUser'
import { deleteItem, transferItem } from '@/api/item'
export default {
  name: 'Dangersetting',
  components: {
    SelectProjectUser
  },

  methods: {
    handleDelete () {
      const _this = this
      _this.$confirm({
        title: '真的要删除这个项目吗？',
        content: (
          <div>
            <p>请输入项目名称确认删除：</p>
            <br/>
            <a-input ref="projectName"/>
          </div>
        ),
        onOk () {
          //
          const projectName = _this.$refs.projectName.stateValue
          if (projectName != _this.$store.getters.projectData.name) {
            _this.$message.error('输入的项目名称不正确')
            return
          }
          return new Promise((resolve, reject) => {
            const projectId = _this.$store.getters.projectId
            deleteItem(projectId).then(res => {
              if (res.code != '200') throw ''
              _this.$message.success('删除成功')
              resolve()
              _this.$store.dispatch('ToHome', { pageName: 'home' })
            }).catch(() => {
              _this.$message.error('删除失败')
              reject()
            })
          })
        },
        onCancel () {}
      })
    },
    handleSave () {
      const _this = this
      const user = this.$refs.user.selectedUser
      if (user.isNull) {
        this.$error({
          title: '错误',
          content: '未指定转让用户'
        })
        return
      }
      this.$confirm({
        title: '真的要转让项目“' + _this.$store.getters.projectData.name + '”吗？',
        content: '单击确定转让项目给用户“' + user.user_name + '”',
        onOk () {
          transferItem({
            item_id: _this.$store.getters.projectId,
            uid: user.uid
          }).then(res => {
            _this.$message.success('转让成功')
            _this.$store.dispatch('ToHome', { pageName: 'home' })
          }).catch(() => {
            _this.$message.error('转让失败')
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>
